import Store from "./Store";
var pendingFilterChange = null;
var clearBypassTimer = null;
var bypassVersion = 0;
var hasUnsavedWorkBlockingFilterChange = function hasUnsavedWorkBlockingFilterChange() {
  var state = Store.getRawState();
  return state.isPatientTagsEditMode || state.isCreatePatientReminderFormOpen || state.isLetterEditorOpenOrMinimized || state.isPatientTaskMinimized;
};
export var startWorklistFilterNavigationBypass = function startWorklistFilterNavigationBypass() {
  bypassVersion += 1;
  Store.update(function (s) {
    s.isApplyingWorklistFilters = true;
  });
  if (typeof window !== "undefined") {
    if (clearBypassTimer) {
      clearTimeout(clearBypassTimer);
    }
    clearBypassTimer = setTimeout(function () {
      clearWorklistFilterNavigationBypass();
    }, 5000);
  }
};
export var requestWorklistFilterChange = function requestWorklistFilterChange(applyFilterChange) {
  if (hasUnsavedWorkBlockingFilterChange()) {
    pendingFilterChange = applyFilterChange;
    Store.update(function (s) {
      s.isWorklistFilterConfirmationOpen = true;
    });
    return;
  }
  startWorklistFilterNavigationBypass();
  applyFilterChange();
};
export var confirmPendingWorklistFilterChange = function confirmPendingWorklistFilterChange() {
  var applyFilterChange = pendingFilterChange;
  pendingFilterChange = null;
  Store.update(function (s) {
    s.isWorklistFilterConfirmationOpen = false;
    s.isPatientTagsEditMode = false;
    s.isCreatePatientReminderFormOpen = false;
    s.worklistFilterDiscardToken += 1;
  });
  if (applyFilterChange) {
    startWorklistFilterNavigationBypass();
    applyFilterChange();
  }
};
export var cancelPendingWorklistFilterChange = function cancelPendingWorklistFilterChange() {
  pendingFilterChange = null;
  Store.update(function (s) {
    s.isWorklistFilterConfirmationOpen = false;
  });
};
export var clearWorklistFilterNavigationBypass = function clearWorklistFilterNavigationBypass(version) {
  if (version !== undefined && version !== bypassVersion) return;
  if (clearBypassTimer && typeof window !== "undefined") {
    clearTimeout(clearBypassTimer);
    clearBypassTimer = null;
  }
  if (!Store.getRawState().isApplyingWorklistFilters) return;
  Store.update(function (s) {
    s.isApplyingWorklistFilters = false;
  });
};
export var isWorklistFilterNavigationBypassActive = function isWorklistFilterNavigationBypassActive() {
  return Store.getRawState().isApplyingWorklistFilters;
};
export var getWorklistFilterNavigationBypassVersion = function getWorklistFilterNavigationBypassVersion() {
  return bypassVersion;
};